import { render, staticRenderFns } from "./Brokerage.vue?vue&type=template&id=c2dac552&"
import script from "./Brokerage.vue?vue&type=script&lang=js&"
export * from "./Brokerage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports